export const PRIMARY_COLOR = '#00945d';
export const SECONDARY_COLOR = '#45b193';
export const TERNARY_COLOR = '#cce9de';
export const BRAND_HEADING_COLOR = '#284e37';
export const MAIN_COLOR = '#263238';
export const ACCENT_ERROR = '#f44336';
export const ACCENT_INFO = '#4e79e6';
export const ICON_COLOR = '#979797';
export const SHADE_COLOR = '#f0f0f0';
export const COMMON_DEFAULT = '#ffffff';
export const CARD_SECONDARY_COLOR = '#f3efe4';
export const INPUT_TEXT_COLOR = '#1a1a1a';
export const OUTLINE_PRIMARY = '#219653';
export const OUTLINE_SECENDARY = '#219653';
export const ICON_LIGHT = '#dadada';
export const LIGHT_ASH = '#dcdcdc';
export const GOLD_HIGHLIGHT = '#ecd92f';
export const GOLD_HIGHLIGHT_LIGHT = '#fffaf5';
export const QUATERARY_COLOR = '#f8d548';
export const TEXT_PRIMARY_COLOR = '#312d2a';
export const TEXT_SECONDARY_COLOR = '#716a63';
export const TEXT_TERNARY_COLOR = '#312d2a';
